import { mapActions, mapState } from 'vuex';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    forCmsWidget: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  computed: {
    ...mapState('app', ['settingShowOdds']),
  },
  methods: {
    ...mapActions('app', ['setSettingShowOdds']),
    onMenuToggle() {
      if (this.forCmsWidget) return;
      this.showMenu = !this.showMenu;
    },
    onClickOutside() {
      this.showMenu = false;
    },
    setOddsMode(value) {
      this.setSettingShowOdds(value);
      this.showMenu = false;
    },
  },
};
